/**
 * Lets a tab tell the hub cards their figures are stale.
 *
 * The cards are fetched once by useHubCounts at the page level, while the
 * things they count are changed inside the tabs — so configuring the first
 * provider would otherwise leave its card reading "Not set up" until a reload.
 * A tiny event bus keeps that one-way: the tabs announce, the hook listens, and
 * neither has to know the other exists (no callback threaded through four
 * components).
 *
 * Mirrors ats-field-mapping's hub-counts-cache, minus the caching.
 */
type Listener = () => void

const listeners = new Set<Listener>()

/** Call after a save that changes a figure on the cards. */
export function invalidateHubCounts(): void {
  // Copied first: a listener that unsubscribes while notifying must not
  // disturb the iteration.
  for (const listener of [...listeners]) {
    listener()
  }
}

/** Subscribe to invalidations; returns the unsubscribe, for useEffect cleanup. */
export function onHubCountsInvalidated(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
